import * as XLSX from 'xlsx';

var dataConversionUtil = {};

dataConversionUtil.dataToExcel = function(fileName,tableHeader,dataList,sheet="sheet1"){
  let aoa = []

  aoa = tableHeader.concat(dataList);

  let workSheet = XLSX.utils.aoa_to_sheet(aoa);
  let workBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workBook,workSheet,sheet);

  XLSX.writeFile(workBook, fileName+'.xlsx');

}

// dataConversionUtil.dataToExcel = function(fileName,tableHeader,dataList,sheet="sheet1"){
//   dataList.unshift(tableHeader[0]);
//   var data = dataList.join('\n');
//   alert(data)
//     // var fileName = "export.xls";
//     var link = document.createElement("a");
//     link.setAttribute("href", 'data:application/vnd.ms-excel;charset=utf-8,' + encodeURIComponent(data));
//     link.setAttribute("download", fileName+'.xls');
//     document.body.appendChild(link); // 这行是为了防止FF浏览器会直接打开新页面
//     link.click();
//     document.body.removeChild(link); // 下载完成移除元素
// }

export { dataConversionUtil }



// WEBPACK FOOTER //
// ./src/utils/excel.js